import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, viewAccount, type StaffAccount } from "./api";
import { Button } from "./components/ui/button";
import { useDashboard } from "./Dashboard";

const day = (at: string | null) => at ? at.slice(0, 10) : "–";

/** God Mode: every account. View opens that account's dashboard in this tab, read only. */
export function StaffPage() {
  const { staff } = useDashboard();
  const [q, setQ] = useState("");
  const accounts = useQuery({ queryKey: ["staff", "accounts", q], queryFn: () => api.staffAccounts(q), enabled: staff });
  if (!staff) return <div className="dash-state"><h2>Page not found</h2><p>This link does not open a Method page.</p></div>;
  const open = (account: StaffAccount) => { viewAccount(account.id); window.location.assign("/"); };
  return (
    <section className="staff-page">
      <p className="staff-note">Open any account to see its dashboard as that person sees it. Nothing can be changed, and each view is logged.</p>
      <input className="staff-search" type="search" placeholder="Search by name or email" value={q}
        onChange={event => setQ(event.target.value)} aria-label="Search accounts" />
      {accounts.error ? <p role="alert">{accounts.error.message} <Button variant="ghost" onClick={() => void accounts.refetch()}>Try again</Button></p>
        : !accounts.data ? <p>Loading accounts…</p>
        : <div className="staff-table-wrap"><table className="staff-table">
            <thead><tr><th>Person</th><th>Organization</th><th>Signed up</th><th>Last seen</th><th>Methods</th><th>Runs</th><th>Last run</th><th /></tr></thead>
            <tbody>{accounts.data.map(account => (
              <tr key={account.id}>
                <td><strong>{account.name || account.email}</strong><small>{account.email}</small></td>
                <td>{account.organization}</td>
                <td>{day(account.created_at)}</td>
                <td>{day(account.last_seen_at)}</td>
                <td>{account.methods}</td>
                <td>{account.runs}</td>
                <td>{day(account.last_run_at)}</td>
                <td><Button onClick={() => open(account)}>View</Button></td>
              </tr>))}
            </tbody>
          </table></div>}
    </section>
  );
}

/** Shown on every page while this tab views another account. */
export function ViewingBanner({ name, email }: { name: string; email: string }) {
  return (
    <div className="viewing-banner" role="status">
      <span>Viewing <strong>{name || email}</strong> ({email}). Read only.</span>
      <button type="button" onClick={() => { viewAccount(null); window.location.assign("/staff"); }}>Exit</button>
    </div>
  );
}
